import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as T_T from 'cryface';

@Component
export default class PropertyInfoRooms extends Vue {
   public title: string = 'PropertyInfoRooms';

   @Prop()
   public data: any;

   @Watch('data', { immediate: true, deep: true })
   public onDataInput(val: any, oldVal: any) {
      this.dataMapper(val);
   }

   public dataMapped: any[] = [];

   public formFields = [
      {
         title: this.getText('propertyDetails.roomsInfo.roomsFields.name'),
         key: 'name'
      },
      {
         title: 'Size',
         key: 'size'
      },
      {
         title: this.getText('propertyDetails.roomsInfo.roomsFields.features'),
         key: 'features'
      }
   ];

   public sizeIsFeet: boolean = true;
   public sizeUnit: string = 'Feet';

   public onSizeIsFeetChange() {
      if (this.sizeIsFeet) {
         this.sizeUnit = 'Feet';
      } else {
         this.sizeUnit = 'Meter';
      }
      this.dataMapper(this.data);
   }

   public getText(str: string) {
      return this.$t(str);
   }

   public dataMapper(data: any[]) {
      const rows: any[] = [];
      if (T_T.simpleDetect(data)) {
         if (data instanceof Array) {
            if (data.length > 0) {
               this.data.map((room: any) => {
                  let name = '';
                  if (T_T.simpleDetect(room.name)) {
                     name += room.name;
                  }
                  if (T_T.simpleDetect(room.level)) {
                     name += ` (${room.level}) `;
                  }
                  const row = {
                     name: name,
                     size: this.sizeIsFeet ? T_T.simpleDetect(room.sizeF) ? room.sizeF : '' : T_T.simpleDetect(room.sizeM) ? room.sizeM : '',
                     features: T_T.simpleDetect(room.descriptions) ? room.descriptions.join(',') : '',
                     level: T_T.simpleDetect(room.level) ? room.level : '',
                  };
                  rows.push(row);
               });
               this.dataMapped = rows;
            }
         }
      }
   }
}
